"use client";

import { MessageCircle } from "lucide-react";
import { Button } from "../../../components/ui/button";
import Link from "next/link";

import { useEffect, useState } from "react";

export function FinalCTASection({ lookUpCMSData, homeDetails }: any) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const SettingList = homeDetails?.SettingList || [];
  const WhatsAppNo = SettingList?.filter(
    (setting: any) => setting?.SettingKey === "WhatsAppNo",
  )[0]?.SettingValue;
  const phone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent("Hello, I’d like to know more details.")}`;

  return (
    <section className="py-32 md:py-48 bg-white relative overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: lookUpCMSData?.["Home - Section 8 : CTA Heading"]
            ? `url("${lookUpCMSData?.["Home - Section 8 : CTA Heading"]?.CMSImage}")`
            : `url('/fallbacks/resort.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A962] to-transparent opacity-50" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A962] to-transparent opacity-50" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {lookUpCMSData?.["Home - Section 8 : CTA Heading"] ? (
            <div
              suppressHydrationWarning={true}
              dangerouslySetInnerHTML={{
                __html:
                  lookUpCMSData?.[
                    "Home - Section 8 : CTA Heading"
                  ]?.Template?.trim(),
              }}
            />
          ) : (
            <>
              <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 px-6 py-3 rounded-full mb-8">
                <span className="text-[#C9A962] tracking-[0.3em] text-sm uppercase">
                  Start Your Journey
                </span>
              </div>
              <h2 className="text-white text-4xl md:text-6xl lg:text-7xl mb-8 leading-tight">
                Your Perfect Escape
                <br />
                <span className="text-[#C9A962]">Is Waiting</span>
              </h2>
              <div className="w-32 h-1 bg-[#C9A962] mx-auto mb-10" />
              <div className="text-white/95 text-xl md:text-2xl max-w-3xl mx-auto mb-14 leading-relaxed">
                Whether it's a quiet retreat, a wild adventure, a family
                holiday, or a once-in-a-lifetime celebration — your journey
                begins here.
              </div>
            </>
          )}

          {isMounted && (
            <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
              <Link
                href={whatsappLink || "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  size="lg"
                  className="bg-white hover:bg-white/90 text-[#B42025] px-10 py-7 text-lg shadow-2xl transition-all duration-300 group"
                >
                  <MessageCircle className="mr-3 h-5 w-5 group-hover:scale-110 transition-transform" />
                  WhatsApp Our Travel Expert
                </Button>
              </Link>
            </div>
          )}

          {lookUpCMSData?.["Home - Section 9 : CTA Statistics"] && (
            <div
              suppressHydrationWarning={true}
              dangerouslySetInnerHTML={{
                __html:
                  lookUpCMSData?.[
                    "Home - Section 9 : CTA Statistics"
                  ]?.Template?.trim(),
              }}
            />
          )}
          {/* Stats */}
          {/* <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-16 border-t border-white/20">
            <div>
              <div className="text-4xl md:text-5xl text-[#C9A962] mb-2">5</div>
              <p className="text-white/80">Unique Destinations</p>
            </div>
            <div>
              <div className="text-4xl md:text-5xl text-[#C9A962] mb-2">
                4.8
              </div>
              <p className="text-white/80">Guest Rating</p>
            </div>
            <div>
              <div className="text-4xl md:text-5xl text-[#C9A962] mb-2">
                1200+
              </div>
              <p className="text-white/80">Happy Guests</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
